import { GAME_ID, PLAY_AREAS, REDUX_ACTIONS, SCREENS } from '../../data/constants';

export const initState = {
  currentScreen: SCREENS.PROGRESS,
  currentPlayArea: PLAY_AREAS.FRIENDS,
};

const screenReducer = (state = initState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    // change play area according to action payload
    case REDUX_ACTIONS.CHANGE_PLAY_AREA:
      return {
        ...state,
        currentPlayArea: payload,
      };

    // change screen according to action payload
    case REDUX_ACTIONS.CHANGE_SCREEN:
      return {
        ...state,
        currentScreen: payload,
      };

    default:
      return state;
  }
};

export default screenReducer;
